// import React, { useState } from 'react';
// import axios from 'axios';

// export default function UploadSection({ setReportUrls, setActiveTab }) {
//   const [loading, setLoading] = useState(false);

//   const [files, setFiles] = useState({
//     sequence: null,
//     multiqc: null,
//     quality: null,
//     quality_plot: null,
//     gc_plot: null,
//     extra_plot: null,
//     logo: null,
//     trimmed_sequence: null,
//     trimmed_multiqc: null,
//     trimmed_quality: null,
//     trimmed_quality_plot: null,
//     trimmed_gc_plot: null,
//     variants_stats: null,
//   });

//   const [genomeZips, setGenomeZips] = useState([]);
//   const [snpeffHtmls, setSnpeffHtmls] = useState([]);

//   const [clientInfo, setClientInfo] = useState({
//     reportTitle: '',
//     clientName: '',
//     institution: '',
//     projectId: '',
//     salesperson: '',
//     contact: '',
//     numberOfSamples: '',
//     species: '',
//     minDP: '50',
//     minQ: '100',
//   });

//   const [mappingInfo, setMappingInfo] = useState({
//     totalScaffoldLength: '',
//     noOfContigs: '',
//     contigN50: '',
//     noOfScaffolds: '',
//     scaffoldsN75: '',
//   });

//   const [softwareSteps, setSoftwareSteps] = useState([]);

//   const handleTextChange = (e) => {
//     setClientInfo({ ...clientInfo, [e.target.name]: e.target.value });
//   };

//   const handleMappingChange = (e) => {
//     setMappingInfo({ ...mappingInfo, [e.target.name]: e.target.value });
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setFiles({ ...files, [e.target.name]: file });
//     }
//   };

//   const handleGenomeZipsChange = (e) => {
//     const selectedFiles = Array.from(e.target.files || []);
//     setGenomeZips(selectedFiles);
//   };

//   const handleSnpeffChange = (e) => {
//     setSnpeffHtmls(Array.from(e.target.files || []));
//   };

//   const handleSubmit = async () => {
//     setLoading(true);

//     const formData = new FormData();

//     if (files.sequence) formData.append('raw_sequence', files.sequence);
//     if (files.multiqc) formData.append('raw_multiqc', files.multiqc);
//     if (files.quality) formData.append('raw_quality', files.quality);
//     if (files.quality_plot) formData.append('quality_plot', files.quality_plot);
//     if (files.gc_plot) formData.append('gc_plot', files.gc_plot);
//     if (files.extra_plot) formData.append('extra_plot', files.extra_plot);
//     if (files.logo) formData.append('logo', files.logo);

//     if (files.trimmed_sequence) formData.append('trimmed_sequence', files.trimmed_sequence);
//     if (files.trimmed_multiqc) formData.append('trimmed_multiqc', files.trimmed_multiqc);
//     if (files.trimmed_quality) formData.append('trimmed_quality', files.trimmed_quality);
//     if (files.trimmed_quality_plot) formData.append('trimmed_quality_plot', files.trimmed_quality_plot);
//     if (files.trimmed_gc_plot) formData.append('trimmed_gc_plot', files.trimmed_gc_plot);

//     if (files.variants_stats) formData.append('variants_stats', files.variants_stats);

//     genomeZips.forEach((zipFile) => {
//       formData.append('genome_zips', zipFile);
//     });

//     snpeffHtmls.forEach((file) => {
//       formData.append('snpeff_htmls', file);
//     });

//     formData.append('clientInfo', JSON.stringify(clientInfo));
//     formData.append('mappingInfo', JSON.stringify(mappingInfo));
//     formData.append('softwareSteps', JSON.stringify(softwareSteps));

//     try {
//       const res = await axios.post('http://localhost:5000/api/generate-report', formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//       });

//       const relativeUrl = res.data.htmlUrl;
//       const fullUrl = `http://localhost:5000${relativeUrl}`;

//       const htmlResponse = await fetch(fullUrl);
//       if (!htmlResponse.ok) throw new Error(`Fetch failed: ${htmlResponse.status}`);

//       const htmlBlob = await htmlResponse.blob();

//       let filename = "OneOmics_QC_Report.html";
//       if (clientInfo.projectId?.trim()) {
//         const safeId = clientInfo.projectId.trim().replace(/[^a-zA-Z0-9_-]/g, '_');
//         const date = new Date().toISOString().slice(0, 10);
//         filename = `${safeId}_${date}_QC_Report.html`;
//       }

//       const blobUrl = window.URL.createObjectURL(htmlBlob);
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(blobUrl);

//       setReportUrls({ html: relativeUrl });
//       setActiveTab('report');
//     } catch (err) {
//       console.error(err);
//       alert('Error: ' + (err.response?.data?.error || err.message));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
//       <div className="max-w-5xl mx-auto">
//         {/* Client & Project Information */}
//         <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border border-gray-200">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-4 border-b border-gray-200">
//             Client & Project Information
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div className="md:col-span-2">
//               <label className="block text-sm font-medium text-gray-700 mb-1">Report Title</label>
//               <input
//                 type="text"
//                 name="reportTitle"
//                 value={clientInfo.reportTitle}
//                 onChange={handleTextChange}
//                 placeholder="e.g. RNA-Seq Quality Control Report – Batch 2026-01"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Client Name</label>
//               <input
//                 type="text"
//                 name="clientName"
//                 value={clientInfo.clientName}
//                 onChange={handleTextChange}
//                 placeholder="e.g. Dr. Manivannan"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Institution / Company</label>
//               <input
//                 type="text"
//                 name="institution"
//                 value={clientInfo.institution}
//                 onChange={handleTextChange}
//                 placeholder="e.g. TNAU"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Project ID</label>
//               <input
//                 type="text"
//                 name="projectId"
//                 value={clientInfo.projectId}
//                 onChange={handleTextChange}
//                 placeholder="e.g. OPL_WGS_6_34567"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Salesperson</label>
//               <input
//                 type="text"
//                 name="salesperson"
//                 value={clientInfo.salesperson}
//                 onChange={handleTextChange}
//                 placeholder="e.g. Gowri Shankar J"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div className="md:col-span-2">
//               <label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
//               <input
//                 type="email"
//                 name="contact"
//                 value={clientInfo.contact}
//                 onChange={handleTextChange}
//                 placeholder="e.g. sales@oneomics.in"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div className="md:col-span-2 mt-6 pt-6 border-t border-gray-200">
//               <h3 className="text-lg font-medium text-gray-700 mb-4">Sequencing Project Details</h3>
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Number of Samples</label>
//               <input
//                 type="number"
//                 name="numberOfSamples"
//                 value={clientInfo.numberOfSamples}
//                 onChange={handleTextChange}
//                 placeholder="e.g. 24"
//                 min="1"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Species / Organism</label>
//               <input
//                 type="text"
//                 name="species"
//                 value={clientInfo.species}
//                 onChange={handleTextChange}
//                 placeholder="e.g. Homo sapiens, Oryza sativa"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Bioinformatics Software Used */}
//         <div className="bg-white rounded-xl shadow-lg p-8 mt-10 border border-gray-200">
//           <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
//             <h2 className="text-2xl font-semibold text-gray-800">
//               Bioinformatics Software Used
//             </h2>
//             <button
//               type="button"
//               onClick={() => setSoftwareSteps([...softwareSteps, { step: "", tool: "", version: "" }])}
//               className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
//             >
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//               </svg>
//               Add Analysis Step
//             </button>
//           </div>

//           {softwareSteps.length === 0 ? (
//             <div className="text-center py-8 text-gray-500">
//               No analysis steps added yet. Click "Add Analysis Step" to begin.
//             </div>
//           ) : (
//             <div className="space-y-6">
//               {softwareSteps.map((item, index) => (
//                 <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end relative bg-gray-50 p-4 rounded-lg">
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Analysis Step
//                     </label>
//                     <input
//                       type="text"
//                       value={item.step}
//                       onChange={(e) => {
//                         const updated = [...softwareSteps];
//                         updated[index].step = e.target.value;
//                         setSoftwareSteps(updated);
//                       }}
//                       placeholder="e.g. Quality Control, Assembly, Variant Calling..."
//                       className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//                     />
//                   </div>

//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Software / Tool
//                     </label>
//                     <input
//                       type="text"
//                       value={item.tool}
//                       onChange={(e) => {
//                         const updated = [...softwareSteps];
//                         updated[index].tool = e.target.value;
//                         setSoftwareSteps(updated);
//                       }}
//                       placeholder="e.g. FastQC, MultiQC, BWA, GATK..."
//                       className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//                     />
//                   </div>

//                   <div className="flex items-end gap-3">
//                     <div className="flex-1">
//                       <label className="block text-sm font-medium text-gray-700 mb-1">
//                         Version
//                       </label>
//                       <input
//                         type="text"
//                         value={item.version}
//                         onChange={(e) => {
//                           const updated = [...softwareSteps];
//                           updated[index].version = e.target.value;
//                           setSoftwareSteps(updated);
//                         }}
//                         placeholder="e.g. 0.11.9, 0.39, latest, 4.2.0"
//                         className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
//                       />
//                     </div>

//                     <button
//                       type="button"
//                       onClick={() => {
//                         if (softwareSteps.length <= 1) return;
//                         const updated = softwareSteps.filter((_, i) => i !== index);
//                         setSoftwareSteps(updated);
//                       }}
//                       className={`p-2.5 rounded-lg transition ${
//                         softwareSteps.length > 1
//                           ? "text-red-600 hover:text-red-800 hover:bg-red-50"
//                           : "text-gray-400 cursor-not-allowed"
//                       }`}
//                       disabled={softwareSteps.length <= 1}
//                       title={softwareSteps.length <= 1 ? "Keep at least one row" : "Remove this step"}
//                     >
//                       <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Upload QC Files */}
//         <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-4 border-b border-gray-200">
//             Upload QC Files
//           </h2>

//           {/* Raw data uploads */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//             <div className={`p-5 border-2 rounded-xl transition-all ${files.sequence ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">Sequence Count Plot (.txt)</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <p className="text-gray-600">Click or drag file here</p>
//                   <p className="text-sm text-gray-500 mt-1">TXT file</p>
//                 </div>
//                 <input type="file" name="sequence" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.sequence && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.sequence.name}
//                 </p>
//               )}
//             </div>

//             <div className={`p-5 border-2 rounded-xl transition-all ${files.multiqc ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">MultiQC FastQC (.txt)</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <p className="text-gray-600">Click or drag file here</p>
//                   <p className="text-sm text-gray-500 mt-1">TXT file</p>
//                 </div>
//                 <input type="file" name="multiqc" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.multiqc && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.multiqc.name}
//                 </p>
//               )}
//             </div>

//             <div className={`p-5 border-2 rounded-xl transition-all ${files.quality ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">Quality Scores Plot (.txt)</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <p className="text-gray-600">Click or drag file here</p>
//                   <p className="text-sm text-gray-500 mt-1">TXT file</p>
//                 </div>
//                 <input type="file" name="quality" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.quality && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.quality.name}
//                 </p>
//               )}
//             </div>

//             <div className={`p-5 border-2 rounded-xl transition-all ${files.quality_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">Per Base Quality Plot</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <div className="text-gray-400 text-4xl mb-3">🖼️</div>
//                   <p className="text-gray-600">Upload image</p>
//                   <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
//                 </div>
//                 <input type="file" name="quality_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.quality_plot && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.quality_plot.name}
//                 </p>
//               )}
//             </div>

//             <div className={`p-5 border-2 rounded-xl transition-all ${files.gc_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">GC Content Plot</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <div className="text-gray-400 text-4xl mb-3">🖼️</div>
//                   <p className="text-gray-600">Upload image</p>
//                   <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
//                 </div>
//                 <input type="file" name="gc_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.gc_plot && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.gc_plot.name}
//                 </p>
//               )}
//             </div>

//             <div className={`p-5 border-2 rounded-xl transition-all ${files.extra_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">Additional Plot</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <div className="text-gray-400 text-4xl mb-3">🖼️</div>
//                   <p className="text-gray-600">Upload image</p>
//                   <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
//                 </div>
//                 <input type="file" name="extra_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.extra_plot && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.extra_plot.name}
//                 </p>
//               )}
//             </div>

//             <div className={`p-5 border-2 rounded-xl transition-all ${files.logo ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//               <h4 className="font-medium text-gray-800 mb-3">Logo (optional)</h4>
//               <label className="cursor-pointer block">
//                 <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                   <div className="text-gray-400 text-4xl mb-3">🖼️</div>
//                   <p className="text-gray-600">Upload your logo</p>
//                   <p className="text-sm text-gray-500 mt-1">PNG / JPG / SVG recommended</p>
//                 </div>
//                 <input type="file" name="logo" accept="image/*" onChange={handleFileChange} className="hidden" />
//               </label>
//               {files.logo && (
//                 <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.logo.name}
//                 </p>
//               )}
//             </div>
//           </div>

//           {/* Trimmed / Clean Data Files */}
//           <div className="mt-12">
//             <h3 className="text-xl font-semibold text-gray-700 mb-6 pb-2 border-b border-gray-200">
//               Trimmed / Clean Data Files
//             </h3>
//             <p className="text-sm text-gray-600 mb-6">
//               Upload the same type of files but for trimmed/clean reads (after adapter trimming and quality filtering).
//             </p>

//             <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
//               <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_sequence ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//                 <h4 className="font-medium text-gray-800 mb-3">Trimmed Sequence Count Plot (.txt)</h4>
//                 <label className="cursor-pointer block">
//                   <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                     <p className="text-gray-600">Click or drag file here</p>
//                     <p className="text-sm text-gray-500 mt-1">fastqc_sequence_count_plot.txt (trimmed)</p>
//                   </div>
//                   <input type="file" name="trimmed_sequence" onChange={handleFileChange} className="hidden" />
//                 </label>
//                 {files.trimmed_sequence && (
//                   <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                     <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                     {files.trimmed_sequence.name}
//                   </p>
//                 )}
//               </div>

//               <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_multiqc ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//                 <h4 className="font-medium text-gray-800 mb-3">Trimmed MultiQC FastQC (.txt)</h4>
//                 <label className="cursor-pointer block">
//                   <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                     <p className="text-gray-600">Click or drag file here</p>
//                     <p className="text-sm text-gray-500 mt-1">multiqc_fastqc.txt (trimmed)</p>
//                   </div>
//                   <input type="file" name="trimmed_multiqc" onChange={handleFileChange} className="hidden" />
//                 </label>
//                 {files.trimmed_multiqc && (
//                   <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                     <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                     {files.trimmed_multiqc.name}
//                   </p>
//                 )}
//               </div>

//               <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_quality ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//                 <h4 className="font-medium text-gray-800 mb-3">Trimmed Quality Scores Plot (.txt)</h4>
//                 <label className="cursor-pointer block">
//                   <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                     <p className="text-gray-600">Click or drag file here</p>
//                     <p className="text-sm text-gray-500 mt-1">fastqc_per_sequence_quality_scores_plot.txt (trimmed)</p>
//                   </div>
//                   <input type="file" name="trimmed_quality" onChange={handleFileChange} className="hidden" />
//                 </label>
//                 {files.trimmed_quality && (
//                   <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                     <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                     {files.trimmed_quality.name}
//                   </p>
//                 )}
//               </div>

//               <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_quality_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//                 <h4 className="font-medium text-gray-800 mb-3">Trimmed Per Base Sequence Quality Plot</h4>
//                 <label className="cursor-pointer block">
//                   <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                     <div className="text-gray-400 text-4xl mb-3">🖼️</div>
//                     <p className="text-gray-600">Upload image</p>
//                     <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
//                   </div>
//                   <input type="file" name="trimmed_quality_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
//                 </label>
//                 {files.trimmed_quality_plot && (
//                   <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                     <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                     {files.trimmed_quality_plot.name}
//                   </p>
//                 )}
//               </div>

//               <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_gc_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//                 <h4 className="font-medium text-gray-800 mb-3">Trimmed Per Sequence GC Content Plot</h4>
//                 <label className="cursor-pointer block">
//                   <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                     <div className="text-gray-400 text-4xl mb-3">🖼️</div>
//                     <p className="text-gray-600">Upload image</p>
//                     <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
//                   </div>
//                   <input type="file" name="trimmed_gc_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
//                 </label>
//                 {files.trimmed_gc_plot && (
//                   <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
//                     <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                     {files.trimmed_gc_plot.name}
//                   </p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Mapping to Reference Genome */}
//         <div className="bg-white rounded-xl shadow-lg p-8 mt-10 border border-gray-200">
//           <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-4 border-b border-gray-200">
//             Mapping to Reference Genome
//           </h2>

//           <h3 className="text-lg font-medium text-gray-700 mb-4">3.1 Statistics of Reference Genome</h3>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Total Scaffold Length</label>
//               <input
//                 type="text"
//                 name="totalScaffoldLength"
//                 value={mappingInfo.totalScaffoldLength}
//                 onChange={handleMappingChange}
//                 placeholder="e.g. 373,795,655"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">No. of Contigs</label>
//               <input
//                 type="text"
//                 name="noOfContigs"
//                 value={mappingInfo.noOfContigs}
//                 onChange={handleMappingChange}
//                 placeholder="e.g. 302"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Contig N50</label>
//               <input
//                 type="text"
//                 name="contigN50"
//                 value={mappingInfo.contigN50}
//                 onChange={handleMappingChange}
//                 placeholder="e.g. 7,711,345"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">No. of Scaffolds</label>
//               <input
//                 type="text"
//                 name="noOfScaffolds"
//                 value={mappingInfo.noOfScaffolds}
//                 onChange={handleMappingChange}
//                 placeholder="e.g. 55"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">Scaffolds N75</label>
//               <input
//                 type="text"
//                 name="scaffoldsN75"
//                 value={mappingInfo.scaffoldsN75}
//                 onChange={handleMappingChange}
//                 placeholder="e.g. 28,443,022"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//           </div>

//           <h3 className="text-lg font-medium text-gray-700 mb-4">3.2 Mapping Statistics</h3>
//           <p className="text-sm text-gray-600">
//             Automatically extracted from <strong>genome_results.txt</strong> files inside each uploaded ZIP (one per sample).
//           </p>

//           <div className={`p-5 border-2 rounded-xl transition-all ${genomeZips.length > 0 ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//             <h4 className="font-medium text-gray-800 mb-3">Genome Results ZIPs (one per sample)</h4>
//             <p className="text-xs text-gray-600 mb-2">Upload ZIP files — each must contain genome_results.txt</p>
//             <label className="cursor-pointer block">
//               <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                 <p className="text-gray-600">Click or drag multiple ZIP files here</p>
//                 <p className="text-sm text-gray-500 mt-1">Multiple .zip files allowed</p>
//               </div>
//               <input
//                 type="file"
//                 multiple
//                 accept=".zip"
//                 onChange={handleGenomeZipsChange}
//                 className="hidden"
//               />
//             </label>

//             {genomeZips.length > 0 && (
//               <div className="mt-4">
//                 <p className="text-sm font-medium text-green-700">
//                   {genomeZips.length} ZIP file{genomeZips.length !== 1 ? 's' : ''} selected
//                 </p>
//                 <ul className="mt-2 space-y-1 text-xs text-gray-600 max-h-40 overflow-y-auto">
//                   {genomeZips.map((file, index) => (
//                     <li key={index} className="flex items-center gap-2">
//                       <span className="text-green-600">✓</span> {file.name}
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Variant Calling Statistics */}
//         <div className="mt-12 pt-8 border-t border-gray-200">
//           <h3 className="text-xl font-semibold text-gray-700 mb-6 pb-2">
//             Variant Calling Statistics (Optional)
//           </h3>

//           <p className="text-sm text-gray-600 mb-6 leading-relaxed">
//             Upload the variant summary file containing the counts of SNPs and InDels.<br />
//             If you have specific filter values (minimum Depth and Quality), enter them below.<br /><br />
//             <strong>File format (tab or space separated):</strong><br />
//             Columns: <strong>Samples</strong> &nbsp; <strong>SNPs</strong> &nbsp; <strong>InDels</strong>
//           </p>

//           <div className={`p-5 border-2 rounded-xl transition-all mb-6 ${
//             files.variants_stats
//               ? 'border-green-500 bg-green-50'
//               : 'border-gray-300 hover:border-blue-400'
//           }`}>
//             <h4 className="font-medium text-gray-800 mb-3">
//               Variant Statistics File (.txt / .tsv)
//             </h4>
//             <label className="cursor-pointer block">
//               <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//                 <div className="text-gray-400 text-4xl mb-3">📊</div>
//                 <p className="text-gray-600 font-medium">Click or drag file here</p>
//                 <p className="text-sm text-gray-500 mt-1">.txt / .tsv</p>
//               </div>
//               <input
//                 type="file"
//                 name="variants_stats"
//                 accept=".txt,.tsv"
//                 onChange={handleFileChange}
//                 className="hidden"
//               />
//             </label>

//             {files.variants_stats && (
//               <div className="mt-4 flex items-center gap-4">
//                 <p className="text-sm text-green-700 font-medium flex items-center gap-2">
//                   <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
//                   {files.variants_stats.name}
//                 </p>
//                 <button
//                   type="button"
//                   onClick={() => setFiles({ ...files, variants_stats: null })}
//                   className="text-sm text-red-600 hover:text-red-800 hover:underline"
//                 >
//                   Remove
//                 </button>
//               </div>
//             )}
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Minimum Depth (DP) used
//               </label>
//               <input
//                 type="number"
//                 name="minDP"
//                 value={clientInfo.minDP}
//                 onChange={handleTextChange}
//                 placeholder="e.g. 50"
//                 min="1"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Minimum Quality (Q) used
//               </label>
//               <input
//                 type="number"
//                 name="minQ"
//                 value={clientInfo.minQ}
//                 onChange={handleTextChange}
//                 placeholder="e.g. 100"
//                 min="1"
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
//               />
//             </div>
//           </div>

//           <p className="mt-4 text-xs text-gray-500 italic">
//             If provided, these values will appear in the report table header (e.g. DP&gt;{clientInfo.minDP || 50} &amp; Q&gt;{clientInfo.minQ || 100})
//           </p>
//         </div>

//         {/* SnpEff HTML Upload Section */}
//         <div className={`p-5 border-2 rounded-xl transition-all mt-8 ${snpeffHtmls.length > 0 ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
//           <h4 className="font-medium text-gray-800 mb-3">
//             SnpEff Variant Annotation Files (HTML)
//           </h4>
//           <p className="text-xs text-gray-600 mb-3">
//             Upload your SnpEff summary HTML files (e.g. PTB33_snps_ann_summary.html, TN1_indels_ann_summary.html, etc.)<br />
//             The report will extract and display the "Number of variants by annotation" table.
//           </p>
//           <label className="cursor-pointer block">
//             <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
//               <p className="text-gray-600 font-medium">Click or drag HTML files here</p>
//               <p className="text-sm text-gray-500 mt-1">Multiple files allowed – no limit</p>
//             </div>
//             <input
//               type="file"
//               multiple
//               accept=".html"
//               onChange={handleSnpeffChange}
//               className="hidden"
//             />
//           </label>

//           {snpeffHtmls.length > 0 && (
//             <div className="mt-4 text-sm">
//               <p className="font-medium text-green-700">
//                 {snpeffHtmls.length} file{snpeffHtmls.length !== 1 ? 's' : ''} selected
//               </p>
//               <ul className="mt-2 space-y-1 text-xs text-gray-700 max-h-48 overflow-y-auto">
//                 {snpeffHtmls.map((file, idx) => (
//                   <li key={idx} className="flex items-center gap-2">
//                     <span className="text-green-600">✓</span> {file.name}
//                   </li>
//                 ))}
//               </ul>
//             </div>
//           )}
//         </div>

//         {/* Submit Button */}
//         <div className="mt-12 text-center">
//           <button
//             onClick={handleSubmit}
//             disabled={loading || !files.sequence || !files.multiqc || !files.quality}
//             className={`px-10 py-4 rounded-xl font-semibold text-white text-lg transition-all transform ${
//               loading || !files.sequence || !files.multiqc || !files.quality
//                 ? 'bg-gray-400 cursor-not-allowed'
//                 : 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800 shadow-lg hover:shadow-xl'
//             } disabled:transform-none`}
//           >
//             {loading ? (
//               <span className="flex items-center justify-center gap-3">
//                 <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
//                   <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
//                 </svg>
//                 Generating Report...
//               </span>
//             ) : 'Generate QC Report'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }





import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../config';

export default function UploadSection({ setReportUrls, setActiveTab }) {
  const [loading, setLoading] = useState(false);
  const [actionType, setActionType] = useState('html');
  const [generatedReport, setGeneratedReport] = useState(null);

  const [files, setFiles] = useState({
    sequence: null,
    multiqc: null,
    quality: null,
    quality_plot: null,
    gc_plot: null,
    extra_plot: null,
    logo: null,
    trimmed_sequence: null,
    trimmed_multiqc: null,
    trimmed_quality: null,
    trimmed_quality_plot: null,
    trimmed_gc_plot: null,
    variants_stats: null,
  });

  const [genomeZips, setGenomeZips] = useState([]);
  const [snpeffHtmls, setSnpeffHtmls] = useState([]);
  const [resourcesZip, setResourcesZip] = useState(null);

  const [clientInfo, setClientInfo] = useState({
    reportTitle: '',
    clientName: '',
    institution: '',
    projectId: '',
    salesperson: '',
    contact: '',
    numberOfSamples: '',
    species: '',
    minDP: '50',
    minQ: '100',
  });

  const [mappingInfo, setMappingInfo] = useState({
    totalScaffoldLength: '',
    noOfContigs: '',
    contigN50: '',
    noOfScaffolds: '',
    scaffoldsN75: '',
  });

  const [softwareSteps, setSoftwareSteps] = useState([]);

  const handleTextChange = (e) => {
    setClientInfo({ ...clientInfo, [e.target.name]: e.target.value });
  };

  const handleMappingChange = (e) => {
    setMappingInfo({ ...mappingInfo, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFiles({ ...files, [e.target.name]: file });
    }
  };

  const handleGenomeZipsChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    setGenomeZips(selectedFiles);
  };

  const handleSnpeffChange = (e) => {
    setSnpeffHtmls(Array.from(e.target.files || []));
  };

  const triggerDownload = (blob, filename) => {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  };

  const handleSubmit = async (format = 'html') => {
    setActionType(format);

    // Fast-path: if report was already generated and user clicks "Export PDF", download PDF directly
    if (format === 'pdf' && generatedReport?.pdfUrl) {
      setLoading(true);
      try {
        const fullPdfUrl = generatedReport.pdfUrl.startsWith('http')
          ? generatedReport.pdfUrl
          : `${API_BASE}${generatedReport.pdfUrl}`;
        const safeId = clientInfo.projectId?.trim().replace(/[^a-zA-Z0-9_-]/g, '_') || 'OneOmics';
        const date = new Date().toISOString().slice(0, 10);
        try {
          const pdfRes = await fetch(fullPdfUrl);
          if (pdfRes.ok) {
            const pdfBlob = await pdfRes.blob();
            triggerDownload(pdfBlob, `${safeId}_${date}_QC_Report.pdf`);
            return;
          }
        } catch (_) {}
        const link = document.createElement('a');
        link.href = fullPdfUrl;
        link.download = `${safeId}_${date}_QC_Report.pdf`;
        document.body.appendChild(link);
        link.click();
        setTimeout(() => { if (document.body.contains(link)) document.body.removeChild(link); }, 500);
        window.open(fullPdfUrl, '_blank');
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
      return;
    }

    setLoading(true);

    const formData = new FormData();

    if (files.sequence) formData.append('raw_sequence', files.sequence);
    if (files.multiqc) formData.append('raw_multiqc', files.multiqc);
    if (files.quality) formData.append('raw_quality', files.quality);
    if (files.quality_plot) formData.append('quality_plot', files.quality_plot);
    if (files.gc_plot) formData.append('gc_plot', files.gc_plot);
    if (files.extra_plot) formData.append('extra_plot', files.extra_plot);
    if (files.logo) formData.append('logo', files.logo);

    if (files.trimmed_sequence) formData.append('trimmed_sequence', files.trimmed_sequence);
    if (files.trimmed_multiqc) formData.append('trimmed_multiqc', files.trimmed_multiqc);
    if (files.trimmed_quality) formData.append('trimmed_quality', files.trimmed_quality);
    if (files.trimmed_quality_plot) formData.append('trimmed_quality_plot', files.trimmed_quality_plot);
    if (files.trimmed_gc_plot) formData.append('trimmed_gc_plot', files.trimmed_gc_plot);

    if (files.variants_stats) formData.append('variants_stats', files.variants_stats);

    genomeZips.forEach((zipFile) => {
      formData.append('genome_zips', zipFile);
    });

    snpeffHtmls.forEach((file) => {
      formData.append('snpeff_htmls', file);
    });

    if (resourcesZip) {
      formData.append('resourcesZip', resourcesZip);
      formData.append('deliverablesZip', resourcesZip);
    }

    formData.append('clientInfo', JSON.stringify(clientInfo));
    formData.append('mappingInfo', JSON.stringify(mappingInfo));
    formData.append('softwareSteps', JSON.stringify(softwareSteps));

    try {
      const res = await axios.post(`${API_BASE}/api/generate-report`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      const relativeUrl = res.data.htmlUrl || res.data.reportUrl;
      const fullUrl = relativeUrl.startsWith('http') ? relativeUrl : `${API_BASE}${relativeUrl}`;
      const relativePdfUrl = res.data.pdfUrl || relativeUrl.replace(/\/index\.html$/i, '/report.pdf');
      const fullPdfUrl = relativePdfUrl.startsWith('http') ? relativePdfUrl : `${API_BASE}${relativePdfUrl}`;

      const safeId = clientInfo.projectId?.trim()
        ? clientInfo.projectId.trim().replace(/[^a-zA-Z0-9_-]/g, '_')
        : 'OneOmics';
      const date = new Date().toISOString().slice(0, 10);

      const reportInfo = {
        htmlUrl: relativeUrl,
        fullHtmlUrl: fullUrl,
        pdfUrl: relativePdfUrl,
        fullPdfUrl: fullPdfUrl,
        qcExcel: res.data.excelUrl,
        mappingExcel: res.data.mappingExcelUrl,
        variantExcel: res.data.variantExcelUrl
      };
      setGeneratedReport(reportInfo);

      if (setReportUrls) {
        setReportUrls({
          html: relativeUrl,
          pdf: relativePdfUrl,
          qcExcel: res.data.excelUrl,
          mappingExcel: res.data.mappingExcelUrl,
          variantExcel: res.data.variantExcelUrl
        });
      }

      const downloadFilename = res.data.filename || `${safeId}_${date}_QC_Report.html`;
      const pdfFilename = res.data.pdfFilename || `${safeId}_${date}_QC_Report.pdf`;

      if (format === 'pdf') {
        const fullPdfDownloadUrl = res.data.pdfDownloadUrl?.startsWith('http')
          ? res.data.pdfDownloadUrl
          : `${API_BASE}${res.data.pdfDownloadUrl || `/api/download-pdf?file=${encodeURIComponent(relativePdfUrl)}&name=${encodeURIComponent(pdfFilename)}`}`;
        const dlLink = document.createElement('a');
        dlLink.href = fullPdfDownloadUrl;
        dlLink.download = pdfFilename;
        document.body.appendChild(dlLink);
        dlLink.click();
        setTimeout(() => { if (document.body.contains(dlLink)) document.body.removeChild(dlLink); }, 500);
      } else {
        // Automatically trigger HTML report file download directly (matching Bacterial WGS, Shotgun, mRNA)
        const downloadUrl = res.data.downloadUrl?.startsWith('http')
          ? res.data.downloadUrl
          : `${API_BASE}${res.data.downloadUrl || `/api/download-report?file=${encodeURIComponent(downloadFilename)}`}`;
        const dlLink = document.createElement('a');
        dlLink.href = downloadUrl;
        dlLink.download = downloadFilename;
        document.body.appendChild(dlLink);
        dlLink.click();
        setTimeout(() => { if (document.body.contains(dlLink)) document.body.removeChild(dlLink); }, 500);

        window.open(fullUrl, '_blank');

        setTimeout(() => {
          const banner = document.getElementById('wgs-success-banner');
          if (banner) {
            banner.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 150);
      }
    } catch (err) {
      console.error(err);
      alert('Error: ' + (err.response?.data?.error || err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Client & Project Information */}
        <div className="bg-white rounded-xl shadow-lg p-8 mb-10 border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-4 border-b border-gray-200">
            Client & Project Information
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Report Title</label>
              <input
                type="text"
                name="reportTitle"
                value={clientInfo.reportTitle}
                onChange={handleTextChange}
                placeholder="e.g. RNA-Seq Quality Control Report – Batch 2026-01"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Client Name</label>
              <input
                type="text"
                name="clientName"
                value={clientInfo.clientName}
                onChange={handleTextChange}
                placeholder="e.g. Dr. Manivannan"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Institution / Company</label>
              <input
                type="text"
                name="institution"
                value={clientInfo.institution}
                onChange={handleTextChange}
                placeholder="e.g. TNAU"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Project ID</label>
              <input
                type="text"
                name="projectId"
                value={clientInfo.projectId}
                onChange={handleTextChange}
                placeholder="e.g. OPL_WGS_6_34567"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Salesperson</label>
              <input
                type="text"
                name="salesperson"
                value={clientInfo.salesperson}
                onChange={handleTextChange}
                placeholder="e.g. Gowri Shankar J"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div className="md:col-span-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">Contact Email</label>
              <input
                type="email"
                name="contact"
                value={clientInfo.contact}
                onChange={handleTextChange}
                placeholder="e.g. sales@oneomics.in"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div className="md:col-span-2 mt-6 pt-6 border-t border-gray-200">
              <h3 className="text-lg font-medium text-gray-700 mb-4">Sequencing Project Details</h3>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Number of Samples</label>
              <input
                type="number"
                name="numberOfSamples"
                value={clientInfo.numberOfSamples}
                onChange={handleTextChange}
                placeholder="e.g. 24"
                min="1"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Species / Organism</label>
              <input
                type="text"
                name="species"
                value={clientInfo.species}
                onChange={handleTextChange}
                placeholder="e.g. Homo sapiens, Oryza sativa"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
          </div>
        </div>

        {/* Bioinformatics Software Used */}
        <div className="bg-white rounded-xl shadow-lg p-8 mt-10 border border-gray-200">
          <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200">
            <h2 className="text-2xl font-semibold text-gray-800">
              Bioinformatics Software Used
            </h2>
            <button
              type="button"
              onClick={() => setSoftwareSteps([...softwareSteps, { step: "", tool: "", version: "" }])}
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Add Analysis Step
            </button>
          </div>

          {softwareSteps.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              No analysis steps added yet. Click "Add Analysis Step" to begin.
            </div>
          ) : (
            <div className="space-y-6">
              {softwareSteps.map((item, index) => (
                <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 items-end relative bg-gray-50 p-4 rounded-lg">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Analysis Step
                    </label>
                    <input
                      type="text"
                      value={item.step}
                      onChange={(e) => {
                        const updated = [...softwareSteps];
                        updated[index].step = e.target.value;
                        setSoftwareSteps(updated);
                      }}
                      placeholder="e.g. Quality Control, Assembly, Variant Calling..."
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Software / Tool
                    </label>
                    <input
                      type="text"
                      value={item.tool}
                      onChange={(e) => {
                        const updated = [...softwareSteps];
                        updated[index].tool = e.target.value;
                        setSoftwareSteps(updated);
                      }}
                      placeholder="e.g. FastQC, MultiQC, BWA, GATK..."
                      className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                    />
                  </div>

                  <div className="flex items-end gap-3">
                    <div className="flex-1">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Version
                      </label>
                      <input
                        type="text"
                        value={item.version}
                        onChange={(e) => {
                          const updated = [...softwareSteps];
                          updated[index].version = e.target.value;
                          setSoftwareSteps(updated);
                        }}
                        placeholder="e.g. 0.11.9, 0.39, latest, 4.2.0"
                        className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
                      />
                    </div>

                    <button
                      type="button"
                      onClick={() => {
                        if (softwareSteps.length <= 1) return;
                        const updated = softwareSteps.filter((_, i) => i !== index);
                        setSoftwareSteps(updated);
                      }}
                      className={`p-2.5 rounded-lg transition ${
                        softwareSteps.length > 1
                          ? "text-red-600 hover:text-red-800 hover:bg-red-50"
                          : "text-gray-400 cursor-not-allowed"
                      }`}
                      disabled={softwareSteps.length <= 1}
                      title={softwareSteps.length <= 1 ? "Keep at least one row" : "Remove this step"}
                    >
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Upload QC Files */}
        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-4 border-b border-gray-200">
            Upload QC Files
          </h2>

          {/* Raw data uploads */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className={`p-5 border-2 rounded-xl transition-all ${files.sequence ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
              <h4 className="font-medium text-gray-800 mb-3">Sequence Count Plot (.txt)</h4>
              <label className="cursor-pointer block">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                  <p className="text-gray-600">Click or drag file here</p>
                  <p className="text-sm text-gray-500 mt-1">TXT file</p>
                </div>
                <input type="file" name="sequence" onChange={handleFileChange} className="hidden" />
              </label>
              {files.sequence && (
                <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.sequence.name}
                </p>
              )}
            </div>

            <div className={`p-5 border-2 rounded-xl transition-all ${files.multiqc ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
              <h4 className="font-medium text-gray-800 mb-3">MultiQC FastQC (.txt)</h4>
              <label className="cursor-pointer block">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                  <p className="text-gray-600">Click or drag file here</p>
                  <p className="text-sm text-gray-500 mt-1">TXT file</p>
                </div>
                <input type="file" name="multiqc" onChange={handleFileChange} className="hidden" />
              </label>
              {files.multiqc && (
                <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.multiqc.name}
                </p>
              )}
            </div>

            <div className={`p-5 border-2 rounded-xl transition-all ${files.quality ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
              <h4 className="font-medium text-gray-800 mb-3">Quality Scores Plot (.txt)</h4>
              <label className="cursor-pointer block">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                  <p className="text-gray-600">Click or drag file here</p>
                  <p className="text-sm text-gray-500 mt-1">TXT file</p>
                </div>
                <input type="file" name="quality" onChange={handleFileChange} className="hidden" />
              </label>
              {files.quality && (
                <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.quality.name}
                </p>
              )}
            </div>

            <div className={`p-5 border-2 rounded-xl transition-all ${files.quality_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
              <h4 className="font-medium text-gray-800 mb-3">Per Base Quality Plot</h4>
              <label className="cursor-pointer block">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                  <div className="text-gray-400 text-4xl mb-3">🖼️</div>
                  <p className="text-gray-600">Upload image</p>
                  <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
                </div>
                <input type="file" name="quality_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
              </label>
              {files.quality_plot && (
                <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.quality_plot.name}
                </p>
              )}
            </div>

            <div className={`p-5 border-2 rounded-xl transition-all ${files.gc_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
              <h4 className="font-medium text-gray-800 mb-3">GC Content Plot</h4>
              <label className="cursor-pointer block">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                  <div className="text-gray-400 text-4xl mb-3">🖼️</div>
                  <p className="text-gray-600">Upload image</p>
                  <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
                </div>
                <input type="file" name="gc_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
              </label>
              {files.gc_plot && (
                <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.gc_plot.name}
                </p>
              )}
            </div>

            <div className={`p-5 border-2 rounded-xl transition-all ${files.extra_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
              <h4 className="font-medium text-gray-800 mb-3">Additional Plot</h4>
              <label className="cursor-pointer block">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                  <div className="text-gray-400 text-4xl mb-3">🖼️</div>
                  <p className="text-gray-600">Upload image</p>
                  <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
                </div>
                <input type="file" name="extra_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
              </label>
              {files.extra_plot && (
                <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.extra_plot.name}
                </p>
              )}
            </div>
          </div>

          {/* Trimmed / Clean Data Files */}
          <div className="mt-12">
            <h3 className="text-xl font-semibold text-gray-700 mb-6 pb-2 border-b border-gray-200">
              Trimmed / Clean Data Files
            </h3>
            <p className="text-sm text-gray-600 mb-6">
              Upload the same type of files but for trimmed/clean reads (after adapter trimming and quality filtering).
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_sequence ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
                <h4 className="font-medium text-gray-800 mb-3">Trimmed Sequence Count Plot (.txt)</h4>
                <label className="cursor-pointer block">
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                    <p className="text-gray-600">Click or drag file here</p>
                    <p className="text-sm text-gray-500 mt-1">fastqc_sequence_count_plot.txt (trimmed)</p>
                  </div>
                  <input type="file" name="trimmed_sequence" onChange={handleFileChange} className="hidden" />
                </label>
                {files.trimmed_sequence && (
                  <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                    <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                    {files.trimmed_sequence.name}
                  </p>
                )}
              </div>

              <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_multiqc ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
                <h4 className="font-medium text-gray-800 mb-3">Trimmed MultiQC FastQC (.txt)</h4>
                <label className="cursor-pointer block">
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                    <p className="text-gray-600">Click or drag file here</p>
                    <p className="text-sm text-gray-500 mt-1">multiqc_fastqc.txt (trimmed)</p>
                  </div>
                  <input type="file" name="trimmed_multiqc" onChange={handleFileChange} className="hidden" />
                </label>
                {files.trimmed_multiqc && (
                  <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                    <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                    {files.trimmed_multiqc.name}
                  </p>
                )}
              </div>

              <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_quality ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
                <h4 className="font-medium text-gray-800 mb-3">Trimmed Quality Scores Plot (.txt)</h4>
                <label className="cursor-pointer block">
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                    <p className="text-gray-600">Click or drag file here</p>
                    <p className="text-sm text-gray-500 mt-1">fastqc_per_sequence_quality_scores_plot.txt (trimmed)</p>
                  </div>
                  <input type="file" name="trimmed_quality" onChange={handleFileChange} className="hidden" />
                </label>
                {files.trimmed_quality && (
                  <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                    <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                    {files.trimmed_quality.name}
                  </p>
                )}
              </div>

              <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_quality_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
                <h4 className="font-medium text-gray-800 mb-3">Trimmed Per Base Sequence Quality Plot</h4>
                <label className="cursor-pointer block">
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                    <div className="text-gray-400 text-4xl mb-3">🖼️</div>
                    <p className="text-gray-600">Upload image</p>
                    <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
                  </div>
                  <input type="file" name="trimmed_quality_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
                </label>
                {files.trimmed_quality_plot && (
                  <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                    <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                    {files.trimmed_quality_plot.name}
                  </p>
                )}
              </div>

              <div className={`p-5 border-2 rounded-xl transition-all ${files.trimmed_gc_plot ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
                <h4 className="font-medium text-gray-800 mb-3">Trimmed Per Sequence GC Content Plot</h4>
                <label className="cursor-pointer block">
                  <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                    <div className="text-gray-400 text-4xl mb-3">🖼️</div>
                    <p className="text-gray-600">Upload image</p>
                    <p className="text-sm text-gray-500 mt-1">PNG / JPG</p>
                  </div>
                  <input type="file" name="trimmed_gc_plot" accept="image/*" onChange={handleFileChange} className="hidden" />
                </label>
                {files.trimmed_gc_plot && (
                  <p className="mt-3 text-sm text-green-700 font-medium flex items-center gap-2">
                    <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                    {files.trimmed_gc_plot.name}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Mapping to Reference Genome */}
        <div className="bg-white rounded-xl shadow-lg p-8 mt-10 border border-gray-200">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 pb-4 border-b border-gray-200">
            Mapping to Reference Genome
          </h2>

          <h3 className="text-lg font-medium text-gray-700 mb-4">3.1 Statistics of Reference Genome</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Total Scaffold Length</label>
              <input
                type="text"
                name="totalScaffoldLength"
                value={mappingInfo.totalScaffoldLength}
                onChange={handleMappingChange}
                placeholder="e.g. 373,795,655"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">No. of Contigs</label>
              <input
                type="text"
                name="noOfContigs"
                value={mappingInfo.noOfContigs}
                onChange={handleMappingChange}
                placeholder="e.g. 302"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Contig N50</label>
              <input
                type="text"
                name="contigN50"
                value={mappingInfo.contigN50}
                onChange={handleMappingChange}
                placeholder="e.g. 7,711,345"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">No. of Scaffolds</label>
              <input
                type="text"
                name="noOfScaffolds"
                value={mappingInfo.noOfScaffolds}
                onChange={handleMappingChange}
                placeholder="e.g. 55"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Scaffolds N75</label>
              <input
                type="text"
                name="scaffoldsN75"
                value={mappingInfo.scaffoldsN75}
                onChange={handleMappingChange}
                placeholder="e.g. 28,443,022"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
          </div>

          <h3 className="text-lg font-medium text-gray-700 mb-4">3.2 Mapping Statistics</h3>
          <p className="text-sm text-gray-600">
            Automatically extracted from <strong>genome_results.txt</strong> files inside your uploaded ZIP.
          </p>

          <div className={`p-5 border-2 rounded-xl transition-all ${genomeZips.length > 0 ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
            <h4 className="font-medium text-gray-800 mb-3">Genome Results ZIP (Single ZIP with all samples, or multiple ZIPs)</h4>
            <p className="text-xs text-gray-600 mb-2">Upload a single ZIP file containing all sample results/genome_results.txt, or separate ZIP files per sample.</p>
            <label className="cursor-pointer block">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                <div className="text-gray-400 text-3xl mb-2">📦</div>
                <p className="text-gray-600 font-medium">Click or drag ZIP file here</p>
                <p className="text-sm text-gray-500 mt-1">Accepts a single .zip containing all samples, or multiple .zip files</p>
              </div>
              <input
                type="file"
                multiple
                accept=".zip,.txt,.tsv"
                onChange={handleGenomeZipsChange}
                className="hidden"
              />
            </label>

            {genomeZips.length > 0 && (
              <div className="mt-4">
                <p className="text-sm font-medium text-green-700">
                  {genomeZips.length} ZIP file{genomeZips.length !== 1 ? 's' : ''} selected
                </p>
                <ul className="mt-2 space-y-1 text-xs text-gray-600 max-h-40 overflow-y-auto">
                  {genomeZips.map((file, index) => (
                    <li key={index} className="flex items-center gap-2">
                      <span className="text-green-600">✓</span> {file.name}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>

        {/* Variant Calling Statistics */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <h3 className="text-xl font-semibold text-gray-700 mb-6 pb-2">
            Variant Calling Statistics (Optional)
          </h3>

          <p className="text-sm text-gray-600 mb-6 leading-relaxed">
            Upload the variant summary file containing the counts of SNPs and InDels.<br />
            If you have specific filter values (minimum Depth and Quality), enter them below.<br /><br />
            <strong>File format (tab or space separated):</strong><br />
            Columns: <strong>Samples</strong> &nbsp; <strong>SNPs</strong> &nbsp; <strong>InDels</strong>
          </p>

          <div className={`p-5 border-2 rounded-xl transition-all mb-6 ${
            files.variants_stats
              ? 'border-green-500 bg-green-50'
              : 'border-gray-300 hover:border-blue-400'
          }`}>
            <h4 className="font-medium text-gray-800 mb-3">
              Variant Statistics File (.txt / .tsv)
            </h4>
            <label className="cursor-pointer block">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                <div className="text-gray-400 text-4xl mb-3">📊</div>
                <p className="text-gray-600 font-medium">Click or drag file here</p>
                <p className="text-sm text-gray-500 mt-1">.txt / .tsv</p>
              </div>
              <input
                type="file"
                name="variants_stats"
                accept=".txt,.tsv"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>

            {files.variants_stats && (
              <div className="mt-4 flex items-center gap-4">
                <p className="text-sm text-green-700 font-medium flex items-center gap-2">
                  <span className="inline-block w-4 h-4 bg-green-500 rounded-full"></span>
                  {files.variants_stats.name}
                </p>
                <button
                  type="button"
                  onClick={() => setFiles({ ...files, variants_stats: null })}
                  className="text-sm text-red-600 hover:text-red-800 hover:underline"
                >
                  Remove
                </button>
              </div>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Minimum Depth (DP) used
              </label>
              <input
                type="number"
                name="minDP"
                value={clientInfo.minDP}
                onChange={handleTextChange}
                placeholder="e.g. 50"
                min="1"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Minimum Quality (Q) used
              </label>
              <input
                type="number"
                name="minQ"
                value={clientInfo.minQ}
                onChange={handleTextChange}
                placeholder="e.g. 100"
                min="1"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
              />
            </div>
          </div>

          <p className="mt-4 text-xs text-gray-500 italic">
            If provided, these values will appear in the report table header (e.g. DP&gt;{clientInfo.minDP || 50} &amp; Q&gt;{clientInfo.minQ || 100})
          </p>
        </div>

        {/* SnpEff HTML Upload Section */}
        <div className={`p-5 border-2 rounded-xl transition-all mt-8 ${snpeffHtmls.length > 0 ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'}`}>
          <h4 className="font-medium text-gray-800 mb-3">
            SnpEff Variant Annotation Files (Single ZIP or HTML files)
          </h4>
          <p className="text-xs text-gray-600 mb-3">
            Upload a <strong>single ZIP file containing all SnpEff summary HTML files</strong> (or upload individual HTML files like PTB33_snps_ann_summary.html, TN1_indels_ann_summary.html, etc.).<br />
            The report will extract and display the "Number of variants by annotation" table.
          </p>
          <label className="cursor-pointer block">
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
              <div className="text-gray-400 text-3xl mb-2">🧬</div>
              <p className="text-gray-600 font-medium">Click or drag ZIP or HTML files here</p>
              <p className="text-sm text-gray-500 mt-1">Accepts one .zip containing all HTML files, or multiple .html files</p>
            </div>
            <input
              type="file"
              multiple
              accept=".html,.htm,.zip"
              onChange={handleSnpeffChange}
              className="hidden"
            />
          </label>

          {snpeffHtmls.length > 0 && (
            <div className="mt-4 text-sm">
              <p className="font-medium text-green-700">
                {snpeffHtmls.length} file{snpeffHtmls.length !== 1 ? 's' : ''} selected
              </p>
              <ul className="mt-2 space-y-1 text-xs text-gray-700 max-h-48 overflow-y-auto">
                {snpeffHtmls.map((file, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <span className="text-green-600">✓</span> {file.name}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {/* Data Files & Deliverables (Resources Tab) */}
        <div className={`p-6 bg-white rounded-xl shadow-lg mt-10 border transition-all ${resourcesZip ? 'border-green-500 bg-green-50/20' : 'border-gray-200'}`}>
          <div className="flex items-start justify-between gap-4 mb-4">
            <div>
              <h3 className="text-xl font-semibold text-gray-800 flex items-center gap-2">
                <span>📁</span> Data Files &amp; Deliverables (Resources Tab)
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                Upload a single ZIP containing only the important final deliverable files you want listed in the report (e.g. final BAM/VCF summary, alignment reports, annotation tables, high-res figures).
              </p>
            </div>
            {resourcesZip && (
              <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Ready
              </span>
            )}
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-3.5 mb-4 text-xs text-blue-900 leading-relaxed flex items-start gap-2.5">
            <span className="text-base flex-shrink-0">💡</span>
            <div>
              <strong>Tip:</strong> Put only final deliverables inside this ZIP (e.g. alignment reports, final variant tables, QC summary plots). These files will appear directly in the report's <strong>Resources</strong> section with individual download buttons and a <strong>Download All (.ZIP)</strong> option.
            </div>
          </div>

          <div className={`p-5 border-2 rounded-xl transition-all ${
            resourcesZip ? 'border-green-500 bg-green-50' : 'border-gray-300 hover:border-blue-400'
          }`}>
            <label className="cursor-pointer block">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 transition">
                <div className="text-gray-400 text-4xl mb-3">📦</div>
                <p className="text-gray-700 font-medium">Click or drag Deliverables ZIP file here</p>
                <p className="text-xs text-gray-500 mt-1">.zip archive containing project deliverables</p>
              </div>
              <input
                type="file"
                accept=".zip"
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (file) setResourcesZip(file);
                }}
                className="hidden"
              />
            </label>

            {resourcesZip && (
              <div className="mt-4 flex items-center justify-between bg-white p-3 rounded-lg border border-gray-200">
                <div className="flex items-center gap-3">
                  <span className="text-xl">🗄️</span>
                  <div>
                    <p className="text-sm font-medium text-gray-800">{resourcesZip.name}</p>
                    <p className="text-xs text-gray-500">{(resourcesZip.size / (1024 * 1024)).toFixed(2)} MB</p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setResourcesZip(null)}
                  className="text-sm text-red-600 hover:text-red-800 font-medium hover:underline"
                >
                  Remove
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Success Banner if already generated */}
        {generatedReport && (
          <div id="wgs-success-banner" className="mt-10 p-5 bg-green-50 border border-green-200 rounded-2xl flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 rounded-full bg-green-100 text-green-600 flex items-center justify-center font-bold">✓</span>
              <div>
                <p className="font-semibold text-green-900">Report Generated Successfully!</p>
                <p className="text-sm text-green-700">You can view the interactive HTML report or download the PDF replica below.</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <a
                href={generatedReport.fullHtmlUrl}
                target="_blank"
                rel="noreferrer"
                className="px-4 py-2 bg-white border border-green-300 text-green-800 rounded-lg font-medium text-sm hover:bg-green-100 transition"
              >
                Open HTML Report ↗
              </a>
              <button
                type="button"
                onClick={() => handleSubmit('pdf')}
                className="px-4 py-2 bg-green-600 text-white rounded-lg font-medium text-sm hover:bg-green-700 transition shadow"
              >
                Download PDF 📄
              </button>
            </div>
          </div>
        )}

        {/* Submit Actions */}
        <div className="mt-12 flex flex-wrap items-center justify-center gap-5">
          <button
            type="button"
            onClick={() => handleSubmit('html')}
            disabled={loading}
            className={`px-8 py-4 rounded-xl font-semibold text-white text-base sm:text-lg transition-all transform flex items-center gap-2 ${
              loading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700 active:bg-blue-800 shadow-lg hover:shadow-xl'
            } disabled:transform-none`}
          >
            {loading && actionType === 'html' ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                </svg>
                Generating Report...
              </span>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <line x1="16" y1="13" x2="8" y2="13"/>
                  <line x1="16" y1="17" x2="8" y2="17"/>
                  <polyline points="10 9 9 9 8 9"/>
                </svg>
                Generate Report
              </>
            )}
          </button>

          <button
            type="button"
            onClick={() => handleSubmit('pdf')}
            disabled={loading}
            className={`px-8 py-4 rounded-xl font-semibold text-white text-base sm:text-lg transition-all transform flex items-center gap-2 ${
              loading
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-rose-600 hover:bg-rose-700 active:bg-rose-800 shadow-lg hover:shadow-xl'
            } disabled:transform-none`}
            title="Export exact design PDF report"
          >
            {loading && actionType === 'pdf' ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" viewBox="0 0 24 24">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                </svg>
                Exporting PDF...
              </span>
            ) : (
              <>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                  <path d="M9 15h6"/>
                  <path d="M12 12v6"/>
                </svg>
                Export PDF Report
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}